import { AppConfig } from '@app/config';
import { UploadedFileInfo } from "./app.interfaces";

export class UploadedFile {
  
  public fileName: string;
  public origFileName: string;
  public type: string;
  public extension: string;
  _url: string;
  
  constructor(fileName: string, origFileName: string, extension: string, type: string) {
    this.fileName = fileName;
    this.origFileName = origFileName;
    this.extension = extension;
    this.type = type;
  }
  
  public static createFromUploadedFileInfo(uploadedFileInfo: UploadedFileInfo){
    return new this(uploadedFileInfo.fileName, uploadedFileInfo.origFileName, uploadedFileInfo.extension, uploadedFileInfo.type);
  }
  
  public get url() {
  	if(this.fileName===null) return null;

    if(! this._url) {
      this._url = AppConfig.apiBaseUrl + '/upload/' + this.type + '/'+this.fileName;  
    }
    return this._url;
  }
  
  
  
  
}


// WEBPACK FOOTER //
// ./src/app/app.models.ts